import React from 'react'
import { Banner } from '../core/Banner'
import { Footer } from '../core/Footer'
import { Navbar } from '../core/Navbar'
import { TopNav } from '../core/TopNav'
import { Content } from '../sections/home/Content'

export const Home = () => {
    return (
        <div>
            <TopNav />
            <Navbar />
            <Banner />
            <Content />
            <Footer />
        </div>
    )
}
